import React from 'react';
import { Button, Form, Radio, Loader } from 'semantic-ui-react';
import { ErrorMessage } from 'formik';
import styled from 'styled-components';
import axios from 'axios';
import { debounce } from 'lodash';
import regexs from '../utilities/regexs';

import FormikInputField from '../componentsFormik/FormikInputField';
//import FormikSelectField from "../componentsFormik/FormikSelectField";

// const optsCountry = [
//     { key: 'en', text: 'England', value: 'England' },
//     { key: 'wa', text: 'Wales', value: 'Wales' },
//     { key: 'sc', text: 'Scotland', value: 'Scotland' },
//     { key: 'oth', text: 'Other', value: 'Other' }
// ];

const API_URL = 'https://maps.googleapis.com/maps/api/geocode/json?address';
const API_KEY = 'AIzaSyDkiE7OEfvzSfcaqnvWq_Gy8OP1ZSxlodw';

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class AddressForm extends React.Component<any, any> {
  updateFieldsDebounced: any;

  constructor(props: any) {
    super(props);
    this.updateFieldsDebounced = debounce(this.updateFields, 2000);
  }

  state = {
    loading: false
  };

  prev = (e: any) => {
    e.preventDefault();
    this.props.prevStep();
  };

  next = (e: any) => {
    e.preventDefault();
    this.props.gaEvent('event', 'Address', 'Next', 'Boots', this.props.isValid);
    this.props.nextStep(this.props);
  };

  geocode = (e: any) => {
    this.setState({
      loading: true
    });

    this.props.handleChange(e);
    this.updateFieldsDebounced(e.target.value);
  };

  updateFields(postCode: any) {
    axios
      .get(`${API_URL}=${postCode}&key=${API_KEY}&sensor=false&components=country:GB`)
      .then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data.results.length
        ) {
          let address = response.data.results[0].address_components;
          let postCode = address[0].long_name;

          if (regexs.postCodeValid.test(postCode)) {

            this.props.setFieldValue('stp3_postCode', postCode);

            for (var i = 0; i < address.length; i++) {
              var currentComponent = address[i];

              if (currentComponent['types'].includes('route')) {
                this.props.setFieldValue(
                  'stp3_streetRoad',
                  currentComponent['short_name']
                );
              } else if (currentComponent['types'].includes('postal_town')) {
                this.props.setFieldValue(
                  'stp3_town',
                  currentComponent['long_name']
                );
              } else if (
                currentComponent['types'].includes('administrative_area_level_1')
              ) {
                let country = currentComponent['long_name'].charAt(0).toUpperCase() + currentComponent['long_name'].slice(1).toLowerCase();
                if (country === 'England' || country === 'Wales' || country === 'Scotland') {
                  this.props.setFieldValue(
                    'stp3_country',
                    currentComponent['long_name'].charAt(0).toUpperCase() + currentComponent['long_name'].slice(1).toLowerCase()
                  );
                } else {
                  this.props.setFieldValue(
                    'stp3_country',
                    'Other'
                  );
                };
              }
            }
          }
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  render() {
    return (
      <React.Fragment>
        <Form.Group grouped>
          <label>Postcode</label>

          <React.Fragment>
            <div className="loader" style={{ margin: '10px 0' }}>
              <Loader inline className={this.state.loading ? 'active' : ''} />
            </div>
          </React.Fragment>

          <FormikInputField
            name="stp3_postCode"
            type="input"
            placeholder="SW1A 2AA"
            onChange={this.geocode}
            data-testid="af-postcode-input"
          />

          <FormikInputField
            name="stp3_houseNumName"
            type="input"
            label="House Number / Name"
            placeholder="11"
            data-testid="af-house-input"
          />

          <FormikInputField
            name="stp3_streetRoad"
            type="input"
            label="Street Name"
            placeholder="Downing Street"
            data-testid="af-street-input"
          />

          <FormikInputField
            name="stp3_town"
            type="input"
            label="Town / City"
            placeholder="London"
            data-testid="af-town-input"
          />

          <Form.Group grouped>
            <label>Country</label>
            <Form.Field>
              <Radio
                label="England"
                name="stp3_country"
                value="England"
                checked={this.props.values.stp3_country === 'England'}
                onChange={() =>
                  this.props.setFieldValue('stp3_country', 'England')
                }
                data-testid="af-radio-england"
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Wales"
                name="stp3_country"
                value="Wales"
                checked={this.props.values.stp3_country === 'Wales'}
                onChange={() =>
                  this.props.setFieldValue('stp3_country', 'Wales')
                }
                data-testid="af-radio-wales"
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Scotland"
                name="stp3_country"
                value="Scotland"
                checked={this.props.values.stp3_country === 'Scotland'}
                onChange={() =>
                  this.props.setFieldValue('stp3_country', 'Scotland')
                }
                data-testid="af-radio-scotland"
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Other"
                name="stp3_country"
                value="Other"
                checked={this.props.values.stp3_country === 'Other'}
                onChange={() =>
                  this.props.setFieldValue('stp3_country', 'Other')
                }
                data-testid="af-radio-other"
              />
            </Form.Field>
            <ErrorMessage
              name={'stp3_country'}
              render={msg => <RedText className="error"> {msg} </RedText>}
            />
          </Form.Group>

          {/* <FormikSelectField
                        name="stp3_country"
                        label="Country"
                        placeholder="England"
                        options={optsCountry}
                    /> */}

          <Button.Group widths="2">
            <Button
              labelPosition="left"
              floated="left"
              color="grey"
              icon="left chevron"
              content="Back"
              onClick={this.prev}
              data-testid="af-back-button"
            />
            <Button
              labelPosition="right"
              floated="right"
              color={this.props.isValid ? 'green' : 'grey'}
              icon="right chevron"
              content="Next"
              onClick={this.next}
              data-testid="af-next-button"
            />
          </Button.Group>
        </Form.Group>
      </React.Fragment>
    );
  }
}

export default AddressForm;
